import { CampaignCustomerModelType } from '@teinor/erp/types/company/customer/campaign/campaignCustomer'
import { useCallback, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { useParams } from 'react-router'
import { ModalOpenedSetTy } from '../../../../../baseComponents/Modal/types'
import { LittleModalCreateEdit } from '../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../forms/FormRenderer/types'
import { useNotSelectedCampaignCustomer } from '../../../../../utils/hooks/customer/useNotSelectedCampaignCustomer'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'


interface ModalCreateCustomerCampaignProps extends ModalEditComponentProps {}

const ModalCreateCustomerCampaign: React.FC<ModalCreateCustomerCampaignProps> = ({ userPermissions, basicData, stopPropagation, ...rest}) => {
    const {t} = useTwinTranslation()
    const { id } = useParams()
    const CustomerId = basicData?.CustomerId || id
    const { campaigns } = useNotSelectedCampaignCustomer({ id: CustomerId || ''})
    const fields: FormRender<CampaignCustomerModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'CampaignId',
                    label: t('campaign', 'Campaña'),
                    component: 'CustomSelectWithSearchBar',
                    items: campaigns || {},
                    required: true
                },
                {
                    name: 'CustomerId',
                    component: 'InputHidden',
                    value: CustomerId
                }
            ]
        }
    ]
    return (
        <LittleModalCreateEdit fields={fields} translations={{
            title: t('addCustomerToCampaign', 'Añadir cliente a la campaña'),
            button: t('add', 'Añadir')
        }} stopPropagation={stopPropagation} haveButtonPermissions={permissionCheck(userPermissions|| false, 'create')} url={'/api/app/customer/campaign/customer/createCampaignCustomer'} {...rest} />
    )
}

interface ModalCreateCustomerCampaignOutsideProps extends ModalCreateCustomerCampaignOutsiderLogicProps { }

export const ModalCreateCustomerCampaignOutside: React.FC<ModalCreateCustomerCampaignOutsideProps> = ({ ...rest }) => {
    const { mySetOpened } = useModalCreateCustomerCampaignOutsiderLogic({...rest})
    return (
        ReactDOM.createPortal(
            <ModalCreateCustomerCampaign {...rest as any} setOpened={mySetOpened} stopPropagation={true} />,
            document.body
        )
    )
}

interface ModalCreateCustomerCampaignOutsiderLogicProps extends ModalEditComponentProps {
    setLockOnClickOut?: (lock: boolean) => void
}
const useModalCreateCustomerCampaignOutsiderLogic = ({ setOpened, setLockOnClickOut }: ModalCreateCustomerCampaignOutsiderLogicProps) => {
    const mySetOpened: ModalOpenedSetTy = useCallback((value) => {
        if (value === null) {
            setLockOnClickOut?.(false)
        }
        setOpened(value)
    }, [setLockOnClickOut, setOpened])

    useEffect(() => {
        setLockOnClickOut?.(true)
    }, [setLockOnClickOut])
    return { mySetOpened }
}

export default ModalCreateCustomerCampaign